import { NavigationFlow } from "../../common/flow";
import type { FlightSteps } from "./FlightNavigationFlowProvider";

const useGoToNextStep = (currentStep: FlightSteps) => {
  return NavigationFlow.useGoToNextStep<FlightSteps>(currentStep);
};

const useGoToStep = () => {
  return NavigationFlow.useGoToStep<FlightSteps>();
};

const useGetCurrentStep = () => {
  return NavigationFlow.useGetCurrentStep<FlightSteps>();
};
export const FlightsNavigationFlow = {
  useGoToNextStep,
  useGoToStep,
  useGetCurrentStep,
};
